module.exports = __webpack_public_path__ + "img/extension.67604de9.png";